/**
 * Oobli Consent Bridge
 *
 * Lazy-loads the Gorgias chat widget once the visitor grants "preferences"
 * consent via Shopify's cookie banner.
 *
 * Google tags (GA4 + Ads) are no longer handled here — they are managed by
 * the Google & YouTube Shopify app through Shopify's Web Pixel / Customer
 * Events API, which is gated by Shopify's native consent banner. The previous
 * Google Consent Mode v2 bridge was removed during that migration.
 */

(function () {
  // --- Debug logging -------------------------------------------------------
  // Flip CONSENT_DEBUG to true while working on consent / Gorgias loading to
  // surface the step-by-step [Oobli Consent] trace in the browser console.
  // Keep it false in production so the console stays quiet. Genuine failures
  // still log via console.error regardless of this flag.
  var CONSENT_DEBUG = false;
  function consentLog() {
    if (CONSENT_DEBUG) console.log.apply(console, arguments);
  }
  function consentWarn() {
    if (CONSENT_DEBUG) console.warn.apply(console, arguments);
  }

  // --- Gorgias chat widget (deferred until preferences consent) ---
  window.__gorgiasLoaded = false;
  window.__loadGorgias = function (consent) {
    if (consent.preferences === 'yes' && !window.__gorgiasLoaded) {
      window.__gorgiasLoaded = true;
      consentLog('[Oobli Consent] Gorgias consent granted — loading chat widget');
      var dataEl = document.getElementById('gorgias-chat-data');
      if (!dataEl) {
        consentWarn('[Oobli Consent] Gorgias data element not found');
        return;
      }
      window.SHOPIFY_PERMANENT_DOMAIN = dataEl.getAttribute('data-permanent-domain');
      window.SHOPIFY_CUSTOMER_ID = dataEl.getAttribute('data-customer-id');
      window.SHOPIFY_CUSTOMER_EMAIL = dataEl.getAttribute('data-customer-email');
      var script = document.createElement('script');
      script.id = 'gorgias-chat-widget-install-v3';
      script.src = dataEl.getAttribute('data-bundle-src');
      document.body.appendChild(script);
    } else {
      consentLog('[Oobli Consent] Gorgias skipped — preferences:', consent.preferences, ', already loaded:', window.__gorgiasLoaded);
    }
  };

  // --- Event listener for banner interactions ---
  document.addEventListener('visitorConsentCollected', function (event) {
    consentLog('[Oobli Consent] visitorConsentCollected event fired, detail:', event.detail);
    var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
    consentLog('[Oobli Consent] currentVisitorConsent():', consent);
    window.__loadGorgias(consent);
  });

  // --- Load consent-tracking-api and check persisted consent ---
  consentLog('[Oobli Consent] Waiting for Shopify.loadFeatures...');

  function initConsentApi() {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) {
          console.error('[Oobli Consent] Failed to load consent-tracking-api:', error);
          return;
        }
        consentLog('[Oobli Consent] consent-tracking-api loaded successfully');

        var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        consentLog('[Oobli Consent] Persisted consent check:', consent);

        if (consent.preferences !== 'no_interaction') {
          consentLog('[Oobli Consent] Returning visitor — applying saved consent');
          window.__loadGorgias(consent);
        } else {
          consentLog('[Oobli Consent] No prior consent decision — waiting for banner interaction');
        }
      }
    );
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    initConsentApi();
  } else {
    consentLog('[Oobli Consent] Shopify not ready yet, deferring to DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', function () {
      if (window.Shopify && window.Shopify.loadFeatures) {
        initConsentApi();
      } else {
        console.error('[Oobli Consent] Shopify.loadFeatures never became available');
      }
    });
  }
})();
